<template>
  <div class="title-actions" @click="$emit('click')">
    <div class="title-actions__container" v-bind:class="{ opened: isOpened }">
      <span
        v-for="action in actions"
        :key="action?.label"
        @click="action?.value()"
        class="title-actions__action"
      >
        <i :class="action?.icon"></i>
        {{ action?.label }}
      </span>
    </div>

    <button class="title-actions__toggle-button" @click="toggleIsOpened">
      {{ openActionsLabel }}

      <i :class="isOpened ? 'ic-chevron-down' : 'ic-chevron-up'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TitleActionsButton',
  emits: ['click'],
  props: {
    openActionsLabel: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    }
  },

  data: () => {
    return {
      isOpened: false
    };
  },

  beforeUnmount() {
    this.isOpened = false;
  },
  methods: {
    toggleIsOpened() {
      this.isOpened = !this.isOpened;
    }
  }
};
</script>

<style theme="dark-theater">
.title-actions {
  position: relative;
}

.title-actions__container {
  display: none;
  position: absolute;
  bottom: 48px;
  border: 1px solid #707070;
  border-bottom: none;
  padding: 1rem 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  flex-direction: column;
  left: 0;
  right: 0;
  background-color: #1a1a1a;
}

.opened {
  display: flex;
}

.title-actions__action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875em;
  padding: 0 4rem;
  height: 58px;
  cursor: pointer;
  transition: 0.4s ease-in-out;
}

.title-actions__action:hover {
  color: var(--primary-color);
}

.title-actions__action i {
  padding-right: 4px;
  margin-right: 4px;
}

.title-actions__toggle-button {
  width: 100%;
  height: 48px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  background-color: var(--primary-color);
  color: #ffff;
  text-transform: uppercase;
  font-size: 0.875em;
  cursor: pointer;
  transition-property: background-color, color;
  transition-duration: 0.3s;
}

.title-actions__toggle-button i {
  margin-left: 0.2rem;
  padding-left: 0.2rem;
}

.title-actions__toggle-button:hover {
  background-color: var(--primary-color-over);
  color: var(--primary-color-over-contrast);
}
</style>








































































